import React from "react";
import "./roi.css";
// import roiImage from "../../assets/ROI/roi-image.svg";
import useIntersectionObserver from "../customHooks/useIntersectionObserver";
import NumberDisplay from "../NumberDisplay";
export default function ROI() {
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.25 });

  const roiStats = [
    {
      value: 40,
      char: "%",
      h3: "Reduction in AI Security Incidents",
      p: "Proactive risk detection and mitigation help reduce AI security incidents.",
    },
    {
      value: 32,
      char: "%",
      h3: "Increase in Operational Resilience",
      p: "Streamlining AI security protocols enhances operational resilience.",
    },
    {
      value: 50,
      char: "%",
      h3: "Improvement in Compliance Efficiency",
      p: "Automated AI security controls simplify compliance management.",
    },
    {
      value: 85,
      char: "%",
      h3: "Improvement in Threat Visibility",
      p: "Comprehensive monitoring and analytics enhance AI threat visibility.",
    },
  ];

  return (
    <section
      className={`roi-section ${isVisible ? "section-animation" : ""}`}
      ref={ref}
      id="three"
    >
      <div className="container">
        <div className="section-heading">
          <div className="heading-tag">
            <span>ROI</span>
          </div>

          <div className="heading-description">
            <h2>Secure AI, Superior Returns </h2>
            <p>Transforming AI Security from Cost Center to Value Creator</p>
          </div>
        </div>

        <div className="roi-content-wrapper">
          <div className="roi-stats-cards row">
            {roiStats.map((item, index) => (
              <div className="roi-card" key={index}>
                <NumberDisplay
                  first={Math.max(item.value - 20, 0)}
                  last={item.value}
                  char={item.char}
                  isVisible={isVisible}
                />
                <h3>{item.h3}</h3>
                <p>{item.p}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
